<script lang="ts">
  import { cn } from '@shared/utils';

  export let name: string;
  export let classes: string = '';
  export let colors: string = 'bg-default-250 dark:bg-dark-400';
  export let rounded: boolean = true;

  const getInitials = (name: string): string => {
    return name.match(/\b\w/g)?.join('').slice(0, 3) || '';
  };

  $: initials = getInitials(name);

  const fontSizes: Record<string, string> = {
    '3': 'text-xs',
    '2': 'text-sm',
    '1': 'text-lg',
  };

  $: fontSizeClass = fontSizes[String(initials.length)] || fontSizes['1'];
</script>

<div
  class="{cn(
    'flex h-full w-full items-center justify-center font-medium uppercase',
    {
      'rounded-full': rounded,
    },
    fontSizeClass,
    colors,
    classes,
  )}"
>
  <span>{initials}</span>
</div>
